module.exports = __webpack_public_path__ + "img/huiyu-back-cp@2x.9e07e75a.png";